import useTestTag from '../../../common/hooks/use-test-tag';
import type { DynamicFieldComponentProps } from '../../dynamic-form/dynamic-form.interfaces';
import ErrorLabel from '../../labels/error-label';
import FieldLabel from '../../labels/field-label';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../tooltip/tooltip';

export interface GeolocationValue {
  address: string;
  latitude: number;
  longitude: number;
}

const Geolocation = ({ name, label, error, value, labelStyles }: DynamicFieldComponentProps<GeolocationValue>) => {
  const tagCreator = useTestTag(label || name || '');
  const tooltipContent = value ? `Latitude: ${value.latitude}, Longitude: ${value.longitude}` : '';

  return (
    <div>
      {label && name && (
        <div className="flex">
          <FieldLabel label={label} name={name} labelStyles={labelStyles} />
        </div>
      )}
      <div ref={tagCreator('value')} className="py-1 text-sm">
        <Tooltip>
          <TooltipTrigger disabled={!value} render={<span>{value?.address ?? ''}</span>} />
          <TooltipContent className="max-w-none whitespace-nowrap">{tooltipContent}</TooltipContent>
        </Tooltip>
      </div>
      {error && <ErrorLabel>{error}</ErrorLabel>}
    </div>
  );
};

export default Geolocation;
